export default __webpack_public_path__ + "./assets/img/logo-cobre-footer.png";